export default import.meta.ROLLDOWN_FILE_URL_11yQHnTxt8hYc5Fxu2Mb7g